// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import React from 'react';

import EmptyState from '../../empty-state/empty-state';
import Showcase from '../../library.showcase/showcase';

import './subject-page__description.scss';

interface Props {
    subjectPages: Array<any>;
    subject: string;
    currentGrade: number | null;
}

const Description = ({ subjectPages, subject, currentGrade }: Props) => {
    const currentPage = subjectPages.find(({ grade }) => grade === currentGrade);

    if (subject === SUBJECTS_SLUGS.custom) {
        return (
            <div className="subject-page__empty">
                <EmptyState
                    textId="library.emptyState.description"
                    unavailableSubjectHeaderId="library.emptyState.unavailableSubject.header"
                />
            </div>
        );
    }

    return <Showcase description={currentPage?.description || ''} />;
};

export default Description;
